import React, { useState, useEffect } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { colors } from "src/assets";
import { useRoute } from "@react-navigation/native";
import { Typography, FormControlLabel } from "src/components";
import { useSales } from "src/hooks";
import { SalesType } from "src/domains";
import LocalText from "src/local";
import { RootStackScreenProps } from "src/navigation/types";

export type WithdrawalNavigationParam = {
  id: string;
};

const accountTypeList = [
  { key: "1", label: "普通" },
  { key: "2", label: "当座" },
  { key: "4", label: "貯蓄" },
];

export const WithdrawalScreen: React.FC = () => {
  const route = useRoute<RootStackScreenProps<"Withdrawal">["route"]>();
  const [sales] = useSales(route.params.id);
  const [typeText, setTypeText] = useState<string>(
    LocalText.screens.withdrawal.typeUndefined
  );
  const [typeTextColor, setTypeTextColor] = useState<string>("black");
  const [createdAt, setCreatedAt] = useState<string>("");
  const [accountTypeText, setAccountTypeText] = useState<string>("");

  useEffect(() => {
    if (sales?.type === SalesType.WITHDRAWAL_REQUEST) {
      setTypeText(LocalText.screens.withdrawal.typeRequest);
      setTypeTextColor("black");
    } else if (sales?.type === SalesType.WITHDRAWAL_PROCESSING) {
      setTypeText(LocalText.screens.withdrawal.typeProcessing);
      setTypeTextColor("#ffc107");
    } else if (sales?.type === SalesType.WITHDRAWAL_APPROVED) {
      setTypeText(LocalText.screens.withdrawal.typeApproved);
      setTypeTextColor("#28a745");
    } else if (sales?.type === SalesType.WITHDRAWAL_REJECTED) {
      setTypeText(LocalText.screens.withdrawal.typeRejected);
      setTypeTextColor("#6c757d");
    } else if (sales?.type === SalesType.WITHDRAWAL_ERROR) {
      setTypeText(LocalText.screens.withdrawal.typeError);
      setTypeTextColor("#dc3545");
    }

    if (sales?.createdAt) {
      const data = new Date(sales?.createdAt);
      setCreatedAt(
        `${data.getFullYear()}年${data.getMonth() + 1}月${data.getDate()}日`
      );

      if (sales.bankAccountType) {
        setAccountTypeText(
          accountTypeList.find(
            (bankAccountTypeListItem) =>
              bankAccountTypeListItem.key === sales.bankAccountType
          )?.label || "unknown"
        );
      }
    }
  }, [sales]);

  // let transferAt = item.transferAt ? new Date(item.transferAt) : null;

  return (
    <View style={styles.root}>
      {sales && (
        <>
          <ScrollView style={styles.scrollView}>
            <FormControlLabel
              text={LocalText.screens.withdrawal.status}
              detail={typeText}
              detailStyle={{ color: typeTextColor }}
            />

            <FormControlLabel
              text={LocalText.screens.withdrawal.createdAt}
              detail={createdAt}
              detailStyle={{ color: "black" }}
            />
            <FormControlLabel
              text={LocalText.screens.withdrawal.requestAmount}
              detail={`${sales.requestAmount}円`}
              detailStyle={{ color: "black" }}
            />
            {(sales.type === SalesType.WITHDRAWAL_REQUEST ||
              sales.type === SalesType.WITHDRAWAL_PROCESSING) && (
              <FormControlLabel
                text={LocalText.screens.withdrawal.fee}
                detail={sales.systemFee ? `${sales.systemFee}円` : "手続き中"}
                detailStyle={{ color: "black" }}
              />
            )}
            {sales.type === SalesType.WITHDRAWAL_APPROVED && (
              <>
                {/*<FormLabel*/}
                {/*  text="システム数料"*/}
                {/*  detail={`${item.systemFee}円`}*/}
                {/*/>*/}
                <FormControlLabel
                  text={LocalText.screens.withdrawal.fee}
                  detail={`${
                    sales.validationFee ||
                    0 + (sales?.approveFee || 0) + (sales?.processingFee || 0)
                  }円`}
                  detailStyle={{ color: "black" }}
                />
                <FormControlLabel
                  text={LocalText.screens.withdrawal.transferAmount}
                  detail={`${sales.transferAmount}円`}
                  detailStyle={{ color: "black" }}
                />
                {/*<FormLabel*/}
                {/*  text="申請日時"*/}
                {/*  detail={transferAt ? `${transferAt.getFullYear()}年${transferAt.getMonth() + 1}月${transferAt.getDate()}日` : '未定'}*/}
                {/*/>*/}
              </>
            )}
            {sales.type === SalesType.WITHDRAWAL_REJECTED && (
              <>
                <FormControlLabel
                  text={LocalText.screens.withdrawal.transferAmount}
                  detail={"0円"}
                  detailStyle={{ color: "black" }}
                />
              </>
            )}
            {sales.type === SalesType.WITHDRAWAL_ERROR && (
              <>
                <FormControlLabel
                  text={LocalText.screens.withdrawal.systemFee}
                  detail={`${
                    (sales?.amount || 0) * -1 - (sales?.systemFee || 0)
                  }円`}
                  detailStyle={{ color: "black" }}
                />
              </>
            )}
            {/*<FormLabel*/}
            {/*  text="振込手数料"*/}
            {/*  detail={`${item.fee}円`}*/}
            {/*/>*/}
            {/*<FormLabel*/}
            {/*  text="振込金額"*/}
            {/*  detail={`${(item.amount * -1) - item.fee}円`}*/}
            {/*/>*/}
            {/*<FormLabel*/}
            {/*  text="振込予定日"*/}
            {/*  detail={`${transferAt.getFullYear()}年${transferAt.getMonth() + 1}月${transferAt.getDate()}日`}*/}
            {/*/>*/}
            <Typography
              text={LocalText.screens.withdrawal.bankSection}
              variant="section"
            />
            <FormControlLabel
              text={LocalText.screens.withdrawal.bankCode}
              detail={sales?.bankCode}
              detailStyle={{ color: "black" }}
            />
            <FormControlLabel
              text={LocalText.screens.withdrawal.bankName}
              detail={sales?.bankName}
              detailStyle={{ color: "black" }}
            />
            <FormControlLabel
              text={LocalText.screens.withdrawal.branchCode}
              detail={sales?.bankBranchCode}
              detailStyle={{ color: "black" }}
            />
            <FormControlLabel
              text={LocalText.screens.withdrawal.branchName}
              detail={sales?.bankBranchName}
              detailStyle={{ color: "black" }}
            />
            <FormControlLabel
              text={LocalText.screens.withdrawal.accountType}
              detail={accountTypeText}
              detailStyle={{ color: "black" }}
            />
            <FormControlLabel
              text={LocalText.screens.withdrawal.accountNumber}
              detail={sales?.bankAccountNumber}
              detailStyle={{ color: "black" }}
            />
            <FormControlLabel
              text={LocalText.screens.withdrawal.accountHolder}
              detail={sales?.bankAccountHolder}
              detailStyle={{ color: "black" }}
            />
          </ScrollView>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    flexDirection: "column",
    backgroundColor: colors.white,
  },
  scrollView: {
    flex: 1,
    backgroundColor: colors.gray1,
  },
  banner: {
    marginHorizontal: 16,
    marginVertical: 8,
  },
  footer: {
    paddingTop: 0,
  },
  formGroup: {
    marginVertical: 8,
  },
});
